// src/components/ui/CardLoader.jsx
import PropTypes from 'prop-types'
import { RefreshCw } from 'lucide-react'
import { cn } from '../../utils/cn'
import { Card, CardContent } from './Card'

const CardLoader = ({ 
  title = 'Loading...', 
  subtitle = '', 
  className = '',
  size = 'lg',
  py = 'py-12'
}) => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8', 
    lg: 'h-8 w-8',
    xl: 'h-12 w-12'
  }

  return (
    <Card className={cn("bg-white", className)}>
      <CardContent className={py}>
        <div className="text-center">
          <RefreshCw className={cn(
            "animate-spin text-orange-500 mx-auto mb-2",
            sizeClasses[size]
          )} />
          <p className="text-gray-500">{title}</p>
          {subtitle && (
            <p className="text-gray-400 text-sm mt-1">{subtitle}</p>
          )}
        </div>
      </CardContent>
    </Card>
  )
}

CardLoader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  py: PropTypes.string
}

export default CardLoader
